import $ from 'jquery';

import 'Lib/jquery.onMutate';
import 'Lib/jquery.easing';
import 'jquery.transit';

import whenDomReady from 'when-dom-ready';
import ViewHeader from 'Views/view-header';
import ViewWishlModal from 'Views/view-wishlModal';

$(document).onCreate('body', () => {

    "use strict";
    
    console.log('Body created, routing...');
    
    var $body = $(document.body);

    if (!$.support.transition) {
        $.fn.transition = $.fn.beforeanimate;
    };
    
    // Global requires
    whenDomReady(function(){
        ORW.Header = new ViewHeader({el: $body});
    });

    // Start routing by template type
    console.log('Routing...' + ' ' + $body.attr('class'));

    if ($body.hasClass('template-index') || $body.hasClass('template-home') || $body.hasClass('page-home')) {
        require('Pages/page-home');
    }

    if ( ($body.hasClass('template-collection') || $body.hasClass('template-search')) && $body.data('tempsuffix') != 'lookbook' ) {
        require('Pages/page-collection');
    }

    if ($body.hasClass('template-product')) {
        require('Pages/page-product');
    }

    if ($body.hasClass('template-cart')) {
        require('Pages/page-cart');
    }

    if ($body.hasClass('template-customers-login') || $body.hasClass('template-customers-register')) {
        require('Pages/page-login');
    }

    if ($body.hasClass('template-customers-account') || $body.hasClass('template-customers-addresses') || $body.hasClass('template-customers-order')) {
        require('Pages/page-account');
    }

    if ( $body.data('tempsuffix') == 'about' ) {
        require('Pages/page-about');
    }

    if ($body.data('tempsuffix') == 'store-locator') {
        require('Pages/page-store-locator');
    }
    
    if ($body.hasClass('template-style-guide') || $body.hasClass('page-style-guide')) {
        require('Pages/page-styleGuide');
    }

    if ( $body.data('tempsuffix') == 'lookbook' ) {
        require('Pages/page-lookbook');
    }

    if ($body.hasClass('template-blog')) {
        require('Pages/page-blog');
    }

    if ($body.hasClass('template-article')) {
        require('Pages/page-article');
    }

    if ($body.hasClass('template-suffix-customer-service') || $body.hasClass('template-suffix-customer-service_2')) {
        require('Pages/page-customer-service');
    }

    if ($body.hasClass('template-giftcard')) {
        require('Pages/page-giftcard');
    }

    if ($body.hasClass('template-checkout')) {
        require('Pages/page-checkout');
    }

    if ( $body.data('tempsuffix') == 'friend' ) {
        require('Pages/page-friend');
    }
});